<div class="flex flex-col lg:flex-row gap-6 mt-6 p-4 items-start w-full">
  <!-- Barre Latérale Skeleton -->
  <aside class="w-full lg:w-72 shrink-0 flex flex-col gap-4">
    <div class="surface-default rounded-xl border border-gray-4 p-4 flex flex-col gap-3 shadow-sm">
      <div class="flex items-center gap-3">
        <ngx-skeleton-loader
          [theme]="{ width: '48px', height: '48px', 'border-radius': '50%', margin: '0' }"
          animation="pulse"
        />
        <div class="flex flex-col gap-2 flex-1">
          <ngx-skeleton-loader
            [theme]="{ width: '80%', height: '16px', 'border-radius': '4px', margin: '0' }"
            animation="pulse"
          />
          <ngx-skeleton-loader
            [theme]="{ width: '60%', height: '12px', 'border-radius': '4px', margin: '0' }"
            animation="pulse"
          />
        </div>
      </div>
      <div class="flex items-center gap-2 pt-2 border-t border-gray-3">
        <ngx-skeleton-loader
          [theme]="{ width: '80px', height: '22px', 'border-radius': '9999px', margin: '0' }"
          animation="pulse"
        />
        <ngx-skeleton-loader
          [theme]="{ width: '70px', height: '22px', 'border-radius': '9999px', margin: '0' }"
          animation="pulse"
        />
      </div>
    </div>

    <!-- Navigation Skeleton -->
    <div class="surface-default rounded-xl border border-gray-4 p-2 flex flex-col gap-1.5 shadow-sm">
      @for (item of [1, 2, 3, 4, 5, 6, 7, 8]; track item) {
        <div class="flex items-center gap-3 px-3 py-2.5">
          <ngx-skeleton-loader
            [theme]="{ width: '20px', height: '20px', 'border-radius': '4px', margin: '0' }"
            animation="pulse"
          />
          <ngx-skeleton-loader
            [theme]="{ width: '100px', height: '14px', 'border-radius': '4px', margin: '0' }"
            animation="pulse"
          />
        </div>
      }
    </div>
  </aside>

  <!-- Main Content Skeleton -->
  <main class="flex-1 min-w-0 w-full flex flex-col gap-6">
    <div class="surface-default rounded-xl border border-gray-4 p-6 flex flex-col gap-4 shadow-sm">
      <ngx-skeleton-loader
        [theme]="{ width: '40%', height: '24px', 'border-radius': '6px', margin: '0' }"
        animation="pulse"
      />
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 pt-2">
        @for (i of [1, 2, 3, 4, 5, 6]; track i) {
          <div class="p-4 bg-gray-1 dark:bg-gray-2 rounded-xl flex flex-col gap-2">
            <ngx-skeleton-loader
              [theme]="{ width: '60px', height: '12px', 'border-radius': '4px', margin: '0' }"
              animation="pulse"
            />
            <ngx-skeleton-loader
              [theme]="{ width: '140px', height: '18px', 'border-radius': '4px', margin: '0' }"
              animation="pulse"
            />
          </div>
        }
      </div>
    </div>
  </main>
</div>
